<!-- PANEL DE NOTIFICACIONES -->
<div
  class="noty-panel theme-panel-lg d-print-none active"
  *ngIf="visibilityNotifications"
>
  <div class="theme-panel-content">
    <div class="notifications-panel">
      Notificaciones
      <button
        type="button"
        class="btn btn-sm btn-danger btn-remove"
        (click)="removeAlert()"
        data-click="noty-panel-expand"
      >
        <i class="far fa-trash-alt"></i> Eliminar todo
      </button>
      <div class="pull-right">
        <a href="javascript:void(0)" (click)="toggleShowTransicion()"
          ><i class="fas fa-times icono"></i
        ></a>
      </div>
    </div>
    <div class="bodypanelboty">
      <div
        class="notification_container notification"
        *ngFor="let item of notificationArrayPush; let i = index"
        [ngClass]="{ active: item.active }"
      >
        <div (click)="seeNotification(i)" class="notification-internal">
          <div href="javascript:void(0)" class="notification_title">
            {{ item.title }}
          </div>
          <div href="javascript:void(0)" class="notification_entry">
            {{ item.body }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
